import { AddCabForm } from '@/components/dashboard/AddCabForm';

export default function HostAddCab() {
  return <AddCabForm />;
}
